'use strict';

var React = require('react'),
    Overlay = require('../atoms/Overlay'),
    KeyCodes = require('../constants/KeyCodes'),
    OverlayStore = require('../stores/OverlayStore'),
    OverlayActionCreators = require('../actions/OverlayActionCreators'),
    ContextMenuActionCreators = require('../actions/ContextMenuActionCreators'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    TimeoutTransitionGroup = require('../utils/TimeoutTransitionGroup');

var OverlayHost = React.createClass({
  mixins: [createStoreMixin(OverlayStore), PureRenderMixin],

  getStateFromStores() {
    return {
      hasAny: OverlayStore.hasAny(),
      hasContextMenu: OverlayStore.hasContextMenu()
    };
  },

  componentDidUpdate(prevProps, prevState) {
    var hasAny = this.state.hasAny;

    if (hasAny && !prevState.hasAny) {
      window.addEventListener('scroll', this.handleScroll, false);
      window.addEventListener('keydown', this.handleKeyDown);
    } else if (!hasAny && prevState.hasAny) {
      window.removeEventListener('scroll', this.handleScroll, false);
      window.removeEventListener('keydown', this.handleKeyDown);
    }
  },

  render() {
    var { hasAny, hasContextMenu } = this.state,
        dimComponent;

    dimComponent = (
      <Overlay key='dim'
           transparent={hasContextMenu}
           onTouchTap={this.handleOverlayTouchTap} />
    );

    if (hasContextMenu) {
      return dimComponent;
    }

    return (
      <TimeoutTransitionGroup transitionName='Overlay'
                              enterTimeout={300}
                              leaveTimeout={300}>
        {hasAny &&
          dimComponent
        }
      </TimeoutTransitionGroup>
    );
  },

  handleOverlayTouchTap() {
    OverlayActionCreators.hideOverlay();
  },

  handleKeyDown(e) {
    if (e.keyCode === KeyCodes.ESCAPE) {
      OverlayActionCreators.hideOverlay();
    }
  },

  handleScroll() {
    if (this.state.hasContextMenu) {
      ContextMenuActionCreators.hideContextMenu();
    }
  }
});

module.exports = OverlayHost;


/** WEBPACK FOOTER **
 ** ./hosts/OverlayHost.jsx
 **/